import React from 'react'
import { useFormContext } from 'react-hook-form'
import useSessionStorage from '../../hooks/useSessionStorage'
import { initialFields } from '../../consts'
import { Information } from '../../assets/icons'

export default function Microchip({ title, label, required = true }) {
  const {
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext()

  const [storageData, setStorageData] = useSessionStorage(
    'app_data',
    initialFields
  )

  const handleChange = (event) => {
    if (event.target.value.length > 15) {
      setValue('MCCRETARITAG.Microchip', event.target.value.substring(0, 15))
    }
    if (event.target.value.length === 15) setStorageData(getValues())
  }

  const handleHelp = () => {
    const elem = document.getElementById('info-microchip')
    if (elem.classList.contains('d-none')) elem.classList.remove('d-none')
    else elem.classList.add('d-none')
  }

  return (
    <div className="form-field">
      {title && <span>{title}</span>}
      <div className="form-group">
        <label
          htmlFor="MCCRETARITAG.Microchip"
          onClick={handleHelp}
        >
          {label || 'Nº de microchip'}
          &nbsp;
          <Information />
        </label>

        <input
          className={`form-control${
            errors.MCCRETARITAG?.Microchip ? ' hasError' : ''
          }`}
          type="text"
          id="MCCRETARITAG.Microchip"
          placeholder={label || 'Nº de microchip'}
          {...register('MCCRETARITAG.Microchip', {
            onChange: handleChange,
            required:
              required === true ? 'El nº de microchip es obligatorio.' : false,
            pattern: {
              value: /^[0-9]+$/i,
              message: 'Has introducido caracteres no permitidos.',
            },
            minLength: {
              value: 15,
              message: 'El nº de microchip tiene que contener 15 dígitos.',
            },
            maxLength: {
              value: 15,
              message: 'El nº de microchip tiene que contener 15 dígitos.',
            },
          })}
        />
        {errors.MCCRETARITAG?.Microchip && (
          <div className="error">{errors.MCCRETARITAG.Microchip.message}</div>
        )}
      </div>
      <div
        id="info-microchip"
        className="info-panel d-none"
      >
        <span onClick={handleHelp}>
          <Information />
        </span>
        El chip, o código alfanumérico de transpondedor, es un&nbsp;
        <strong>número único de identificación para tu perro</strong>. Se
        encuentra en <strong>su cartilla o pasaporte</strong>, y también puede
        verificarse en el veterinario, donde, mediante un lector especial, se
        pueden consultar los datos asociados al microchip.
      </div>
    </div>
  )
}
